import React from 'react'
import Features from '../components/features/features'
import Header from '../components/header/header'
import Partners from '../components/partners/partners'
import Download from '../components/download/download'
import Faq from '../components/faq/Faq'
import Testimony from '../components/testimonials/Testimony'

const Home = () => {
  return (
    <div>
      <Header />
      <Partners />
      <Features />
      <Download />
      <Testimony />
      <Faq />
    </div>
  )
}

export default Home
